import api from '@/services/api'

export const updateUserStage = async (userId, stageId) => {
    try {
        return api.put(`/users/${userId}/update-stage`, {
            event_id: stageId,
            type: 'force',
        })
    } catch (e) {
        console.log(e)
    }
}
